import {axiosInstance} from "@/http-common";

export function removeGeofencing(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.delete(`/api/v1/data/geofencing/${ id }`)
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}

export function removeGeofencingEvent(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.delete(`/api/v1/data/geofencing_events/${ id }`)
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}